import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { LOGO_PRIMARY } from "@/lib/brand";
import { track } from "@/lib/analytics";

const LOGO = LOGO_PRIMARY;

export default function Footer() {
 return (
 <footer
 data-testid="site-footer"
 className="relative mt-32 pt-20 pb-8 px-6 md:px-10"
 style={{
 background:
 "linear-gradient(180deg, #0A0908 0%, #0d0b09 60%, #06050400 100%)",
 borderTop: "1px solid #2A2522",
 }}
 >
 <div className="max-w-[1480px] mx-auto grid md:grid-cols-12 gap-12">
 <div className="md:col-span-5">
 <img
 src={LOGO}
 alt="Harris Homes LLC"
 width={600}
 height={275}
 className="h-24 w-auto -ml-2 mb-6"
 style={{
 filter: "drop-shadow(0 0 18px rgba(197,160,89,0.14))",
 }}
 />
 <p
 className="text-sm leading-relaxed max-w-md"
 style={{ color: "var(--hh-text-dim)" }}
 >
 A premium residential builder rooted in Tahlequah,
 Oklahoma. Custom homes, remodels and thoughtful
 additions, built with patience, precision, and pride.
 </p>
 </div>

 <div className="md:col-span-3">
 <div className="overline mb-5">Navigate</div>
 <ul className="space-y-3">
 {[
 { to: "/", label: "Home" },
 { to: "/about", label: "About" },
 { to: "/services", label: "Services" },
 { to: "/projects", label: "Projects" },
 { to: "/contact", label: "Contact" },
 ].map((l) => (
 <li key={l.to}>
 <Link
 data-testid={`footer-link-${l.label.toLowerCase()}`}
 to={l.to}
 className="font-nav text-[11px] hover:text-[var(--hh-gold-light)] transition-colors"
 style={{ color: "var(--hh-text)" }}
 >
 {l.label}
 </Link>
 </li>
 ))}
 </ul>
 </div>

 <div className="md:col-span-4">
 <div className="overline mb-5">Connect</div>
 <ul
 className="space-y-4 text-sm"
 style={{ color: "var(--hh-text)" }}
 >
 <li className="flex items-start gap-3">
 <Phone
 size={16}
 strokeWidth={1.4}
 style={{
 color: "var(--hh-gold)",
 marginTop: 2,
 }}
 />
 <a
 data-testid="footer-phone"
 href="tel:+19183734341"
 className="hover:text-[var(--hh-gold-light)] transition-colors"
 >
 (918) 373-4341
 </a>
 </li>
 <li className="flex items-start gap-3">
 <Mail
 size={16}
 strokeWidth={1.4}
 style={{
 color: "var(--hh-gold)",
 marginTop: 2,
 }}
 />
 <a
 data-testid="footer-email"
 href="mailto:4harrishomes@gmail.com"
 onClick={() => track.emailClick("footer")}
 className="hover:text-[var(--hh-gold-light)] transition-colors break-all"
 >
 4harrishomes@gmail.com
 </a>
 </li>
 <li className="flex items-start gap-3">
 <MapPin
 size={16}
 strokeWidth={1.4}
 style={{
 color: "var(--hh-gold)",
 marginTop: 2,
 }}
 />
 <span data-testid="footer-location">
 Tahlequah, Oklahoma
 </span>
 </li>
 <li className="flex items-start gap-3">
 <Facebook
 size={16}
 strokeWidth={1.4}
 style={{
 color: "var(--hh-gold)",
 marginTop: 2,
 }}
 />
 <a
 data-testid="footer-facebook"
 href="https://www.facebook.com/p/Harris-Homes-61571695310257/"
 target="_blank"
 rel="noopener noreferrer"
 onClick={() => track.facebookClick("footer")}
 className="hover:text-[var(--hh-gold-light)] transition-colors"
 >
 Follow on Facebook
 </a>
 </li>
 </ul>
 </div>
 </div>

 <div className="gold-rule max-w-[1480px] mx-auto mt-16 mb-6" />

 <div
 className="max-w-[1480px] mx-auto flex flex-col md:flex-row items-center justify-between gap-3 text-[11px]"
 style={{ color: "var(--hh-text-dim)" }}
 >
 <div
 className="font-nav"
 data-testid="footer-copyright"
 >
 © {new Date().getFullYear()} Harris Homes LLC · All Rights
 Reserved
 </div>
 <div
 className="opacity-60 tracking-[0.2em] flex items-center gap-5"
 data-testid="footer-credit"
 style={{ fontFamily: "Outfit, sans-serif", fontSize: 10 }}
 >
 <Link
 to="/privacy"
 data-testid="footer-privacy-link"
 className="hover:text-[var(--hh-gold-light)] transition-colors tracking-[0.2em]"
 >
 PRIVACY
 </Link>
 <a
 href="https://builtby-ab.com"
 target="_blank"
 rel="noopener noreferrer"
 data-testid="footer-built-by-ab"
 className="transition-colors hover:text-[var(--hh-gold-light)]"
 >
 Built by AB
 </a>
 </div>
 </div>
 </footer>
 );
}
